import React, { useState, useEffect } from 'react';
import '../styles/ContactPage.css';

export const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    category: 'general',
    message: '',
    newsletter: true
  });

  useEffect(() => {
    const originalOverflow = document.body.style.overflow;

    // Force scroll to top FIRST
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

    

    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);


  const [formStatus, setFormStatus] = useState({
    submitting: false,
    submitted: false,
    error: false
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault(); // 🔥 THIS IS CRITICAL

  setFormStatus({ submitting: true, submitted: false, error: false });

  try {
    const response = await fetch(
      'https://formsubmit.co/ajax/utterradiouk@gmail.com',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          category: formData.category,
          message: formData.message,
          _subject: `New Contact Form Submission: ${formData.subject || 'No Subject'}`,
          _template: 'table',
          _captcha: 'false'
        })
      }
    );

    if (!response.ok) throw new Error('Submit failed');

    setFormStatus({ submitting: false, submitted: true, error: false });

    setFormData({
      name: '',
      email: '',
      subject: '',
      category: 'general',
      message: '',
      newsletter: true
    });

    setTimeout(() => {
      setFormStatus(prev => ({ ...prev, submitted: false }));
    }, 5000);

  } catch (err) {
    console.error(err);
    setFormStatus({ submitting: false, submitted: false, error: true });
  }
};


  return (
    <>
      <div className="pageContainer">
      {/* Contact Page Header */}
      <section className="news-page-header">
        <h1>
          Contact Us
        </h1>
        <p>Have a question? Get in touch with our team.</p>
      </section>

      {/* Apply Card */}
      <div className="apply-card">
        <div className="apply-header" style={{ background: 'var(--primary)' }}>
          <h3>Apply for Utter Radio</h3>
        </div>
        <div className="apply-body">
          <a href="https://forms.gle/cDXb4ZktcFSbpT6J7" target="_blank" rel="noreferrer" aria-label="Audio Drama Team">Audio Drama Team</a>
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSeLveSvTaNSQt7s70U1E185HEwRyXxUXE5gzLq2W2Gnw04z8Q/viewform" target="_blank" rel="noreferrer" aria-label="Breakfast & Drivetime">Breakfast & Drivetime</a>
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSfUw61dA8f9zvSOSUhEVCsieZ9vJvt4HVMoC9GNEApk88ObYw/viewform" target="_blank" rel="noreferrer" aria-label="Radio Show/Podcast">Radio Show/Podcast</a>
        </div>
      </div>

      {/* Contact Layout */}
      <div className="contact-layout">
        {/* Contact Form */}
        <div className="contact-form-card">
          <div className="contact-form-header" style={{ background: 'var(--primary)' }}>
            <h3>Send Us a Message</h3>
          </div>
          <div className="contact-form-body">
            {/* Success/Error Messages */}
            {formStatus.submitted && (
              <div className="form-response success">
                <i className="fas fa-check-circle"></i> Thank you for your message! We'll get back to you within 24-48 hours.
              </div>
            )}
            
            {formStatus.error && (
              <div className="form-response error">
                <i className="fas fa-exclamation-triangle"></i> There was an error sending your message. Please try again or contact us directly.
              </div>
            )}
            
            <form 
              action="https://formsubmit.co/utterradiouk@gmail.com" 
              method="POST"
              onSubmit={handleSubmit}
              className={formStatus.submitting ? 'form-loading' : ''}
            >
              {/* FormSubmit Configuration */}
              <input type="hidden" name="_subject" value={`New Contact Form Submission: ${formData.subject || 'No Subject'}`} />
              <input type="hidden" name="_template" value="table" />
              <input type="hidden" name="_captcha" value="false" />
              <input type="hidden" name="_autoresponse" value="Thank you for contacting Utter Radio! We've received your message and will get back to you soon." />
              <input type="hidden" name="_next" value={`${window.location.origin}/contact?success=true`} />
              
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">
                    Full Name <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    placeholder="Your name"
                    disabled={formStatus.submitting}
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="email">
                    Email Address <span className="required">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    placeholder="you@example.com"
                    disabled={formStatus.submitting}
                  />
                </div>
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="subject">
                    Subject <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleInputChange}
                    required
                    placeholder="What is this regarding?"
                    disabled={formStatus.submitting}
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="category">
                    Category
                  </label>
                  <select
                    id="category"
                    name="category"
                    value={formData.category}
                    onChange={handleInputChange}
                    disabled={formStatus.submitting}
                  >
                    <option value="general">General Inquiry</option>
                    <option value="support">Technical Support</option>
                    <option value="music">Music Submission</option>
                    <option value="advertising">Advertising</option>
                    <option value="partnership">Partnership</option>
                    <option value="feedback">Feedback</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>
              
              <div className="form-group">
                <label htmlFor="message">
                  Your Message <span className="required">*</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                  placeholder="Tell us what's on your mind..."
                  disabled={formStatus.submitting}
                />
              </div>
              
              <button 
                type="submit" 
                className="btn" 
                style={{ background: '#fff', color: '#333' }}
                disabled={formStatus.submitting}
              >
                {formStatus.submitting ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i> Sending...
                  </>
                ) : (
                  <>
                    Send Message
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
        
        {/* Contact Information Sidebar */}
        <div className="contact-info-sidebar">
          {/* Contact Info Card */}
          <div className="contact-info-card">
            <h3>
              <i className="fas fa-info-circle"></i> Contact Information
            </h3>
            <ul className="contact-info-list">
              <li className="contact-info-item">
                <div className="contact-info-icon">
                  <i className="fas fa-envelope"></i>
                </div>
                <div className="contact-info-content">
                  <h4>General Email</h4>
                  <a href="mailto:utterradiouk@gmail.com">utterradiouk@gmail.com</a>
                </div>
              </li>
              <li className="contact-info-item">
                <div className="contact-info-icon">
                  <i className="fas fa-envelope"></i>
                </div>
                <div className="contact-info-content">
                  <h4>Tech Support Email</h4>
                  <a href="tech@utter-radio.co.uk">tech@utter-radio.co.uk</a>
                </div>
              </li>
              <li className="contact-info-item">
                <div className="contact-info-icon">
                  <i className="fa-brands fa-whatsapp"></i>
                </div>
                <div className="contact-info-content">
                  <h4>Whatsapp</h4>
                  <a href="https://chat.whatsapp.com/LgFLnsIbKbEDkiyRidxbbL" target="_blank" rel="noreferrer" aria-label="Whatsapp">Join Group</a>
                </div>
              </li>
              <li className="contact-info-item">
                <div className="contact-info-icon">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <div className="contact-info-content">
                  <h4>Studio Address</h4>
                  <p>
                    Orange Tower,<br />
                    Salford,<br />
                    M50 2HE</p>
                </div>
              </li>
            </ul>
            
            {/* Social Links */}
            <div style={{ marginTop: '1.5rem' }}>
              <h4 style={{ marginBottom: '1rem', fontSize: '1rem' }}>
                <i className="fas fa-share-alt"></i> Follow Us
              </h4>
              <div className="social-links">
                <a href="https://www.facebook.com/utterradio" target="_blank" rel="noreferrer" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
                <a href="https://x.com/Utter_Radio" target="_blank" rel="noreferrer" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
                <a href="https://www.instagram.com/utterradio" target="_blank" rel="noreferrer" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
                <a href="https://www.youtube.com/@utterradio" target="_blank" rel="noreferrer" aria-label="YouTube"><i className="fab fa-youtube"></i></a>
              </div>
            </div>
          </div>
          </div>
      </div>
      </div>
    </>
  );
};